/* Upsell do cart drawer com cor + tamanho (snippets/cart-drawer-size-upsell.liquid).
   Carregado uma vez fora do #CartDrawer: o drawer troca o próprio HTML a cada atualização
   e os <slyce-size-upsell> novos são inicializados pelo connectedCallback. */
(function () {
  if (window.customElements.get('slyce-size-upsell')) return;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* A partir de 3 itens no carrinho, a lista de itens ganha rolagem própria (itens + um pedaço do próximo)
     para o "Complete o kit" continuar visível logo abaixo. Medido nos itens reais: a altura muda entre desktop e mobile. */
  var VISIBLE_ITEMS_DESKTOP = 2; /* rolagem a partir de 3 itens */
  var VISIBLE_ITEMS_MOBILE = 2;  /* rolagem a partir de 3 itens */
  var PEEK = 0.35;
  var MAX_BODY_SHARE = 0.5; /* em telas baixas, a lista nunca passa de metade da área do carrinho */
  function limitCartItems() {
    var list = document.querySelector('#CartDrawer .drawer__cart-items-wrapper');
    if (!list) return;
    var items = list.querySelectorAll('.cart-item');
    var visible = window.matchMedia('(max-width: 749px)').matches ? VISIBLE_ITEMS_MOBILE : VISIBLE_ITEMS_DESKTOP;
    if (!document.querySelector('#CartDrawer .size-upsell') || items.length <= visible) {
      list.style.maxHeight = '';
      list.classList.remove('size-upsell-scroll');
      return;
    }
    var next = items[visible];
    var offset = next.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
    if (offset <= 0) return; /* drawer ainda sem layout */
    var maxHeight = offset + next.offsetHeight * PEEK;
    var body = list.closest('.cart-drawer__body');
    if (body && body.clientHeight) maxHeight = Math.min(maxHeight, body.clientHeight * MAX_BODY_SHARE);
    list.style.maxHeight = Math.round(maxHeight) + 'px';
    list.classList.add('size-upsell-scroll');
  }
  var limitTimer;
  function scheduleLimit() {
    clearTimeout(limitTimer);
    limitTimer = setTimeout(limitCartItems, 30);
  }
  window.addEventListener('resize', scheduleLimit);
  /* fotos dos itens que terminam de carregar mudam a altura */
  document.addEventListener('load', function (event) {
    if (event.target.tagName === 'IMG' && event.target.closest('#CartDrawer .cart-item')) scheduleLimit();
  }, true);

  class SlyceSizeUpsell extends HTMLElement {
    connectedCallback() {
      /* o drawer re-renderiza a cada mudança no carrinho e recria este elemento */
      scheduleLimit();
      if (this.initialized) return;
      this.initialized = true;
      var data = this.querySelector('script[type="application/json"]');
      try {
        this.colors = data ? JSON.parse(data.textContent) : [];
      } catch (e) {
        this.colors = [];
      }
      this.wrapper = this.closest('.size-upsell');
      this.select = this.querySelector('[data-upsell-color]');
      if (this.select) {
        this.select.addEventListener('change', this.showColor.bind(this));
      }
      this.addEventListener('click', this.onClick.bind(this));
    }

    showColor() {
      var color = this.colors[+this.select.value];
      if (!color) return;
      this.hideError();
      var img = this.querySelector('[data-upsell-image]');
      if (img && color.img) {
        img.src = color.img;
        img.alt = img.alt.split(' — ')[0] + ' — ' + color.n;
      }
      var price = this.querySelector('[data-upsell-price]');
      if (price) {
        /* p/c vêm do filtro money do próprio tema, que já sai em HTML (o app de moeda envolve o valor em spans) */
        price.innerHTML = (color.c ? '<s class="size-upsell__compare">' + color.c + '</s>' : '') +
          '<span>' + color.p + '</span>';
      }
      var title = (this.querySelector('.size-upsell__title') || {}).textContent || '';
      this.querySelector('[data-upsell-sizes]').innerHTML = color.s.map(function (size) {
        var wide = color.s.length === 1 && !color.n ? ' size-upsell__size--wide' : '';
        return '<button type="button" class="size-upsell__size' + (size.a ? '' : ' is-soldout') + wide + '"' +
          ' data-variant-id="' + size.id + '"' + (size.a ? '' : ' disabled') +
          ' aria-label="' + escapeHtml(title + ' ' + color.n + ' ' + size.l) + '">' + escapeHtml(size.l) + '</button>';
      }).join('');
    }

    onClick(event) {
      var button = event.target.closest('[data-variant-id]');
      if (!button || button.disabled || this.busy) return;
      event.preventDefault();
      this.addToCart(button);
    }

    addToCart(button) {
      var self = this;
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : [];
      var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

      this.busy = true;
      this.hideError();
      this.classList.add('is-busy');
      button.classList.add('is-loading');

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: Number(button.dataset.variantId),
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (state) {
          if (state.status) {
            self.showError(state.description || state.message);
            return;
          }
          if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
            drawer.renderContents(state);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function () {
          self.showError();
        })
        .finally(function () {
          self.busy = false;
          self.classList.remove('is-busy');
          button.classList.remove('is-loading');
        });
    }

    showError(message) {
      var el = this.querySelector('[data-upsell-error]');
      if (!el) return;
      el.textContent = message || (this.wrapper && this.wrapper.dataset.errorLabel) || 'Não foi possível adicionar.';
      el.hidden = false;
    }

    hideError() {
      var el = this.querySelector('[data-upsell-error]');
      if (el) el.hidden = true;
    }
  }

  window.customElements.define('slyce-size-upsell', SlyceSizeUpsell);
})();
